import React, { useEffect, useState } from 'react';
import { loadCountryZones, decideZone } from '../../utils/timezones';

// The time zone of a company, client location, district, district manager or guard, worked out rather than
// picked (utils/timezones): read-only text when there is one answer, a list of just the country's zones
// when it has several. onChange(zone) is called whenever the zone is worked out or chosen (null: none yet).
// latitude / longitude: only for a client location, whose zone comes from its map position.
export default function TimeZoneField({ country, value, onChange, latitude, longitude }) {
	const [zones, setZones] = useState(null);

	useEffect(() => {
		let current = true;
		setZones(null);
		loadCountryZones(country).then((list) => {
			if (current) {
				setZones(list);
			}
		});
		return () => { current = false; };
	}, [country]);

	const decided = zones === null ? null : decideZone(zones, value, latitude, longitude);
	const zone = decided ? decided.zone : null;

	useEffect(() => {
		if (decided && (zone || null) !== (value || null)) {
			onChange(zone);
		}
		// Only when the worked-out zone changes (not on every new onChange function)
	}, [zone, decided && decided.source]);

	const text = (content) => <div className="location-text-input" style={{ border: 'none', paddingLeft: 0 }}>{content}</div>;

	if (!country) {
		return text('Choose the country first: the time zone comes from it');
	}
	if (decided === null) {
		return text('Working out the time zone…');
	}
	if (decided.source === 'none') {
		return text('No time zone is known for this country');
	}
	if (decided.source === 'position') {
		return text('Time zone: ' + zone + ' (from the map position)');
	}
	const positionHint = decided.positionZone && zones.indexOf(decided.positionZone) === -1
		? <div style={{ color: '#856404', fontSize: '0.9em' }}>The map position is in {decided.positionZone}, which is not in this country: check the country.</div>
		: null;
	if (decided.source === 'country') {
		return <div>{text('Time zone: ' + zone + ' (from country)')}{positionHint}</div>;
	}
	return (
		<div>
			<select className="location-text-input" value={zone || ''} onChange={(event) => onChange(event.target.value || null)} required>
				<option value="">Choose the time zone…</option>
				{zones.map((name) => <option key={name} value={name}>{name.replace(/_/g, ' ')}</option>)}
			</select>
			{positionHint}
		</div>
	);
}
